import { MIN_PASSWORD_LENGTH } from "../constants";

/**
 * Validadores del formulario de usuarios (UsuarioForm)
 */

/**
 * Comprueba que el nombre de usuario tenga contenido tras recortar espacios.
 */
export const esUsernameValido = (username) => String(username ?? "").trim().length > 0;

/**
 * Comprueba que el email sea obligatorio y tenga un formato válido.
 * Regex simple (algo@algo.algo), suficiente para validación de formulario:
 * la validación real de existencia la hace el backend al crear/actualizar.
 */
export const esEmailValido = (email) => {
    const valor = String(email ?? "").trim();
    if (!valor) return false;

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor);
};

/**
 * Comprueba el password según el modo del formulario: en alta es obligatorio
 * (longitud mínima MIN_PASSWORD_LENGTH); en edición es opcional (vacío = no
 * cambiar la contraseña actual), pero si se escribe algo debe cumplir la
 * misma longitud mínima que en alta.
 */
export const esPasswordValido = (password, { esEdicion = false } = {}) => {
    const valor = String(password ?? "");

    if (esEdicion && valor === "") return true;

    return valor.length >= MIN_PASSWORD_LENGTH;
};

/**
 * Comprueba que la confirmación coincide con el password. Si el password
 * viene vacío (edición sin cambiar la contraseña) no hay nada que confirmar,
 * así que se considera válido independientemente de lo que traiga la
 * confirmación.
 */
export const coincidePassword = (password, confirmarPassword) => {
    if (String(password ?? "") === "") return true;

    return password === confirmarPassword;
};
